import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
//import { adminGetUsers } from '@services/users.service';
import { NavLink } from "react-router-dom";
//import moment from 'moment';
import {
  adminDeleteSpecificCheckpoint,
  adminUpdateBulkStatusCheckpoint,
} from "@services/checkpoint.service";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import SearchHeader from "@components/common/SearchHeader";
import Notfound from "@components/Not-Found";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import ScrollableReactTable from "@components/ScrollableDatatable";
import {
  createSupportTicket,
  exportSupport,
  getSupportList,
} from "@services/support.service";
import { formatText } from "@_common/format-text";
import { tableStatusStyle } from "@_common/colors";
import SupportAddPopup from "../Add/OpenDetails";
import SimpleReactValidator from "simple-react-validator";
import NoAccessPage from "@components/common/NoAccess";
import { concatString } from "@_common/text-helpers";
import { currentDate } from "@_common/date-helpers";
import FooterWrapper from "@components/common/FooterWrapper";
import MoreSupportSvgComponent from "../../../assets/svg-components/left-menu/more-support";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import SupportSvgComponent from "../../../assets/svg-components/support";
import NewWindowSvgComponent from "../../../assets/svg-components/new-window";
import { getUserGuideList } from "@services/email-template.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import VideoSvgComponent from "../../../assets/svg-components/video";
import DocumentSvgComponent from "../../../assets/svg-components/document";
import DownloadNoCircleSvgComponent from "../../../assets/svg-components/download-nocircle";
import ReactTooltip from "react-tooltip";
import { sanitizeInput } from "@_common/dompurify";

interface ICheckpointActiveProps {}

const SupportOpen: React.FunctionComponent<ICheckpointActiveProps> = (
  props: any
) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
    if (props.permissionAPITriggered) {
      getUserGuideData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const [userGuideList, setUserGuideList] = useState([]);
  const getUserGuideData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    try {
      let payload = {
        // page_no: params.page_no ? parseInt(params.page_no) : 1,
        // page_size: params.limit ? parseInt(params.limit) : limit,
        // search_text: params.search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await getUserGuideList(queryRequest);
      if (resp) {
        setUserGuideList(getValue(resp, `data.user_guides`, []));
        // setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      // user_type: "CLIENT",
      support_status: "OPEN",
    };

    if (getValue(props, `permissions`, []).includes("view_all")) {
      payload.view_all = true;
    }

    
    let queryRequest = QueryRequestHelper(payload);

    try {
      setIsLoading(true);
      let resp = await getSupportList(queryRequest);
      // let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setIsLoading(false);
        setList(
          getValue(resp, `data.supports`, []).map((item: object) => ({
            ...item,
            support_status: formatText(getValue(item, `support_status`, "")),
            module: formatText(getValue(item, `module`, "")),
            severity: formatText(getValue(item, `severity`, "")),
            description: concatString(getValue(item, `description`, ""), 400),
            ticket_title: concatString(getValue(item, `ticket_title`, ""), 300),
            user_type: formatText(getValue(item, `user_type`, "")),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleChangeActiveStatus = async () => {
    try {
      let resp = await adminUpdateBulkStatusCheckpoint({
        ids: selectedIDs,
        is_active: false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificCheckpoint(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.status = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/support/details/${id}`);
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Ticket Number",
        accessor: "ticket_number",
        width: 100,
        Cell: ({ row }: any) => {
          return (
            <NavLink to={`/support/open/details/${row.original.id}`}>
              {row.values.ticket_number}
            </NavLink>
          );
        },
      },
      {
        Header: "Ticket Title",
        accessor: "ticket_title",
        width: 350,
      },
      {
        Header: "Description",
        accessor: "description",
        width: 450,
      },
      {
        Header: "Severity",
        accessor: "severity",
        width: 100,
      },
      {
        Header: "Support Status",
        accessor: "support_status",
        width: 100,
      },
      {
        Header: "Module",
        accessor: "module",
        width: 100,
      },
      // {
      // 	Header: "Action",
      // 	width: 250,
      // 	Cell: ({ row }: any) => {
      // 		return (
      // 			<>
      // 				<Button
      // 					color="primary"
      // 					onClick={() => handleEdit(row.original.id)}
      // 				>
      // 					Edit
      // 				</Button>
      // 				&nbsp;&nbsp;&nbsp;
      // 				<Button
      // 					color="danger"
      // 					onClick={() =>
      // 						handleDeleteFun(row.original.id, row.values.checkpoint_id)
      // 					}
      // 				>
      // 					Delete
      // 				</Button>
      // 			</>
      // 		);
      // 	},
      // },
    ],
    []
  );
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
    return {};
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const rowClick = (obj: object) => {
    navigate(`/support/open/details/${getValue(obj, `original.id`, "")}`);
  };
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  /* -------------------------------------------------------------------------- */
  /*                                Add Popup section                           */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);

  const [request, setRequest] = useState({
    module: "REPORTS",
    severity: "HIGH",
    ticket_title: "",
    description: "",
  });

  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleChangeRequest = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: sanitizeInput(value),
    });
  };

  const handleChangeSelect = (e: any, name: string) => {
    setRequest({
      ...request,
      [name]: e.value,
    });
  };

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  let [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        let payload = request;
        setSubmitLoading(true);
        let resp = await createSupportTicket(payload);
        if (resp) {
          setSubmitLoading(false);
          toast.success(getValue(resp, `message`, ""));
          reset();
          handleModal();
          getData();
          simpleValidator.current.hideMessages();
          forceUpdate(0);
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };

  const reset = () => {
    setRequest({
      ...request,
      module: "REPORTS",
      severity: "HIGH",
      ticket_title: "",
      description: "",
    });
  };

  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    let payload: any = {
      report_type: "SUPPORT",
      report_name: `support_report_${currentDate()}`,
      user_type: "CLIENT",
      support_status: "OPEN",
      is_report: "true",
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      view_all:"true",
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await exportSupport({
        ...payload,
      });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/SUPPORT`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle1 = () => setDropdownOpen((prevState) => !prevState);
  const handleNavigateSupport = () => {
    navigate(`/support/open`);
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "support_support_open"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
            />
          )}
          {/* <div className="dashboard-wrapper__header">
            <h4 className="dashbaord-wrapper__header-title">Support</h4>
          </div> */}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MoreSupportSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Support
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Open</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
            <ReactTooltip id="subHeaderSupport" effect="solid" place="bottom">
                Support 
            </ReactTooltip>
              {getValue(userGuideList, `length`, 0) > 0 && 
                <div className="support-dropdown mx-1">
                 
                  <Dropdown isOpen={dropdownOpen} toggle={toggle1}>
                    <DropdownToggle className="p-0" data-tip
                        data-for="subHeaderSupport">
                      <div className="header__dropdown m-0 sub-header-icons-holder">
                        <div className="d-flex cursor-pointer justify-content-center icons-btn w-auto px-3" 
                          style={{color: "#5f6368"}}
                        >
                          {/* <SupportSvgComponent /> */} User Guide
                        </div>
                        {/* <span className="dd-name">Support</span> */}
                      </div>
                    </DropdownToggle>
                    <DropdownMenu>
                      <div className="support-dropdown-item-header">
                        <p>User Guide</p>
                        <span onClick={toggle1} className="close-svg">
                          <img src="/images/close-black.svg" width={`18px`} />
                        </span>
                      </div>

                      
                        <div className="support-list-holder">
                          {getValue(userGuideList, `length`, 0) > 0 &&
                            userGuideList.map((item: object) => {
                              return (
                                <DropdownItem
                                  className="support-dropdown-item"
                                  onClick={() => {
                                    getValue(item, `type`, "") === "document"
                                      ? handleDownloadOnClick(
                                          getValue(item, `document.url`, ""),
                                          getValue(item, `document.name`, "")
                                        )
                                      : window.open(getValue(item, `video_url`, ""));
                                  }}
                                >
                                  <div className="d-flex align-items-center ">
                                    {(getValue(item, `type`, "") === "document") ? <DocumentSvgComponent /> : <VideoSvgComponent />}
                                    
                                    <div className="support-list-name ms-2">{concatString(getValue(item, `name`, ""), 25)}</div>
                                    <span className="redirect-color">
                                    {(getValue(item, `type`, "") === "document") ? <DownloadNoCircleSvgComponent size={18} /> : <NewWindowSvgComponent />}
                                      {/* <NewWindowSvgComponent /> */}
                                    </span>
                                  </div>
                                </DropdownItem>
                              );
                            })}
                        </div>
                      <div className="contact-us-wrap">
                        <div className="contact-title contact-color">
                          Contact us
                        </div>
                        <div
                          className="verify-support contact-color"
                          onClick={handleNavigateSupport}
                        >
                          Verify Support Request
                        </div>
                      </div>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              }
              <RightMenuHeaders
                route={"/support/open/add"}
                isAdd={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                add={
                  getValue(props, `permissions`, []).includes("update")
                    ? "true"
                    : "false"
                }
                handleAddFun={handleModal}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                // download section
                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
                //Line Seperator of button
                lineSeperator={true}
              />
            </div>
          </div>

          <div className={`main-page-layout-wrapper`}>
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/support/open/add"}
                  isAdd={
                    getValue(props, `permissions`, []).includes("update")
                      ? true
                      : false
                  }
                  add={
                    getValue(props, `permissions`, []).includes("update")
                      ? "true"
                      : "false"
                  }
                  handleAddFun={handleModal}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={false}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  isFilterVisible={false}
                  //download section
                  downloadSelfComplianceReport={true}
                  handleDownloadSelfComplianceReport={
                    handleDownloadSelfComplianceReport
                  }
                  downloadLoading={downloadLoading}
                />
              </div>

              {isLoading ? (
                <Loader />
              ) : getValue(list, `length`, 0) > 0 ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  checkboxlogo
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {getValue(list, `length`, 0) !== 0 ? (
                    <>
                      <Notfound />
                    </>
                  ) : (
                    <Notfound />
                  )}
                </>
              )}
            </div>
            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
            <DeleteModal
              isOpen={isDelete}
              handleModal={handleDelete}
              handleSubmit={handleDeleteFunction}
              deleteValue={deleteValue}
            />
            <SupportAddPopup
              isOpen={isOpen}
              handleModal={handleModal}
              handleChangeRequest={handleChangeRequest}
              request={request}
              simpleValidator={simpleValidator}
              handleChangeSelect={handleChangeSelect}
              submitLoading={submitLoading}
              handleSubmit={handleSubmit}
              permissions={getValue(props, `permissions`, [])}
            />
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default SupportOpen;
